import { useAppDispatch, useAppSelector } from "../../hooks"
import { Auth } from "./Auth"
import { Loading } from "./Loading"
import { selectCheckedCurrentSessionValid } from "./authSlice"
import { isCurrentSessionValid } from "./authThunks"

function Session() {
  const checkedCurrentSessionValid = useAppSelector(
    selectCheckedCurrentSessionValid,
  )
  // Check if user has an active session before showing login screen.
  // Needed if user reloads the page but is already logged in, to
  // prevent forcing the user to log in again.
  const dispatch = useAppDispatch()
  if (!checkedCurrentSessionValid) {
    dispatch(isCurrentSessionValid())
  }

  return checkedCurrentSessionValid ? <Auth /> : <Loading />
}

export default Session
